import { PricePerMonth } from "../../../components/organisms/Basket/components"
import { TENANTS } from "../../../constants"
import { extractLinkTags, isItalianTenant, isPdiRetailTenant, loc } from "../../../core/utils"
import { containsMoreThanLinks, findTextBetweenTwoSeparators } from "../../../utils/StringUtils"
import { TunnelDataContext } from "../../context/TunnelDataContext"
import { withPackContext } from "../../hoc/withPackContext"
import { withTunnelDataContext } from "../../hoc/withTunnelDataContext"
import Service from "./Service"
import clsx from "clsx"
import DOMPurify from "dompurify"
import React, { useContext, useEffect, useState } from "react"
import { Col } from "react-bootstrap"

function renderPriceByTenant(tenant, difference, monthlyTotal) {
  let servicePriceText = null

  if (isItalianTenant(tenant)) {
    servicePriceText = <h2>{`${monthlyTotal} €${loc(`/month`)}`}</h2>
  } else {
    servicePriceText = difference > 0 ? <h2>{`+ ${difference.toFixed(2)} €${loc(`/month`)}`}</h2> : null
  }

  return <span className="service-price">{servicePriceText === null ? null : servicePriceText}</span>
}

const Pack = ({ packContext, option, cheapestPackPrice, selectedPack, selectPack }) => {
  const { tunnelData } = useContext(TunnelDataContext)
  const { tenant } = tunnelData
  const { packs } = packContext
  const [selected, setSelected] = useState(false)
  const difference = option.rentDTO.monthlyTotal - cheapestPackPrice

  useEffect(() => {
    if (selectedPack?.servicePackDTO?.id === option?.servicePackDTO?.id) {
      setSelected(true)
    } else {
      setSelected(false)
    }
  }, [option, packs, selectedPack])

  const formatPrice = (price) => {
    if (isNaN(price)) return
    return tenant === TENANTS.SAMSUNG_NL ? `€${price}` : `${price} €`
  }

  const insurancePolicy = findInsurancePolicyDiv(option.servicePackDTO.description)
  const containsMoreThanALink = containsMoreThanLinks(insurancePolicy)

  return (
    <Col className="text-center service-container hard-shadow-white-block d-flex flex-column" style={{ gap: "1rem" }}>
      <section className="card-sections">
        <h4>{option.servicePackDTO.name}</h4>
      </section>

      {renderPriceByTenant(tenant, difference, option.rentDTO.monthlyTotal)}

      {isPdiRetailTenant(tenant) && !!packContext && (
        <div className="d-flex flex-column d-lg-none">
          <PricePerMonth
            simplified={true}
            servicePackPriceFromRentAmount={option?.rentDTO?.monthlyAllServicesWithoutInsuranceAmount}
            servicePackPriceFromRentMessage={
              formatPrice(option?.rentDTO?.monthlyAllServicesWithoutInsuranceAmount?.toFixed(2)) || formatPrice(0)
            }
            country={"FR"}
            duration={packContext?.duration}
            monthlyTotal={formatPrice(option?.rentDTO?.monthlyTotal || formatPrice(0))}
          />
          <span>
            {loc("Upfront")} : {formatPrice(option?.rentDTO?.firstCustomerPayment || 0)}
          </span>
          {extractLinkTags(option.servicePackDTO.description).map((link) => (
            <div
              key={link}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(link, {
                  ADD_ATTR: ["target"]
                })
              }}
            ></div>
          ))}
        </div>
      )}

      <div className="btn-group-toggle" data-toggle="buttons">
        <label
          className={clsx(
            "btn btn-outline-primary-small",
            !selected && "btn-outline-primary",
            selected && "btn-clicked ico-check-small-before active"
          )}
          onClick={() => selectPack(option)}
        >
          {!selected && <div>{loc("Choose")}</div>}
        </label>
        {insurancePolicy ? (
          <section
            className={clsx("card-sections", containsMoreThanALink && "text-left")}
            key={insurancePolicy}
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(insurancePolicy, {
                ADD_ATTR: ["target"]
              })
            }}
          ></section>
        ) : <section className="card-sections"></section>}
      </div>
      <Service option={option} />
    </Col>
  )
}

export function findInsurancePolicyDiv(description) {
  const firstSeparator = `<div id="divInsurancePolicy" style="display: none;">`
  const lastSeparator = `</div>`
  let divInsurancePolicy = undefined

  if (description.search(`id="divInsurancePolicy"`) > -1) {
    divInsurancePolicy = findTextBetweenTwoSeparators(description, firstSeparator, lastSeparator)
  }
  return divInsurancePolicy
}

export default withTunnelDataContext(withPackContext(Pack))
